const config = {};
config.API_URL = process.env.NODE_ENV === 'development' ? 'http://localhost/api/v1': '/api/v1'  ;

export {config};


// WEBPACK FOOTER //
// ./src/config.js